import store from 'lib/store';
import BaseAuth from './BaseAuth';

class Auth extends BaseAuth {
  getRedirect = () => {
    return window && ['/', '/sign-in'].indexOf(window.location.pathname) === -1
      ? `${window.location.pathname}${window.location.search || ''}`
      : '/discover/events';
  };
  loginSocial = provider => {
    if (window) {
      window.location.href = `/auth/${provider}?clientId=${this.clientId
        }&redirect=${encodeURIComponent(this.getRedirect())}`;
    }
  };
  logoutNew = token => {
    const payload = {
      refreshToken: `Bearer ${token}`,
    };
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    };
    return fetch(
      `${process.env.MS_API_GATEWAY_URL}/api/iam/v1/auth/logout`,
      requestOptions,
    )
      .then(res => {
        return res;
      })
      .catch(e => {
        return e;
      });
  };
  logout = async () => {
    // we are duplicating here, since it doesn't appear to be possible to call
    // an async super method, e.g. await super.logout();
    const refTk = await store.get('refreshToken');
    const logT = await this.logoutNew(refTk);
    if (logT) {
      await store.delete('accessToken');
      await store.delete('refreshToken');
      // const delCr = await this.deleteCredentials();
      if (window) {
        setTimeout(() => window.location.replace('/discover/events'), 500);
      }
    }
  };
}

export default new Auth({
  baseUrl: process.env.APP_URL,
  clientId: process.env.WEB_CLIENT_ID,
  credentials: 'same-origin',
  isDev: process.env.NODE_ENV === 'development',
});
